import { Injectable, signal, computed } from '@angular/core';
import { UsersService } from '../api/users.api.service';
import { finalize, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UsersStore {
  private readonly _users = signal<any[]>([]);
  private readonly _isLoading = signal(false);
  private readonly _error = signal<string | null>(null);

  readonly users = computed(() => this._users());
  readonly isLoading = computed(() => this._isLoading());
  readonly error = computed(() => this._error());
  readonly hasData = computed(() => this._users().length > 0);

  constructor(private usersService: UsersService) {}

  load(options: { force?: boolean } = {}): Observable<any[]> {
    const { force = false } = options;

    // If already loaded and not forcing → just return current value as Observable
    if (!force && this._users().length > 0) {
      return of(this._users());
    }

    this._isLoading.set(true);
    this._error.set(null);

    return this.usersService.list().pipe(
      tap({
        next: (users) => {
          this._users.set(users ?? []);
        },
        error: (err) => {
          this._error.set('Error loading users');
          this._users.set([]);
        },
      }),
      finalize(() => {
        this._isLoading.set(false);
      })
    );
  }

  refresh(): Observable<any[]> {
    return this.load({ force: true });
  }

  /** Get User by ID*/
  getById(id: string): any | undefined {
    return this._users().find((e) => e.id === id);
  }

  /** Get only the user_name by id */
  getNameById(id: string): string | null {
    const entity = this.getById(id);
    return entity ? entity.user_name : null;
  }
}
